/**
 * 站点个人信息、公司信息与产品数据
 * 改内容只需改这个文件，不用动组件
 */

// 入行年份，首页从业年数按此动态计算
const CAREER_START_YEAR = 2015;

export const profile = {
  name: "穆雄雄",
  // 首页第一屏的身份定位，一句话说清楚在做什么
  headline: "做医疗与医保信息化，也做自己的产品",
  intro:
    "山西吕梁人，现在在济南。从酒店前台自学编程入行，在学校教了五年计算机，之后转做研发。现在主要做医疗与医保方向的信息化系统——慢病管理、长护险、医保监管，业余开发自己的小程序与开源工具，在 CSDN 持续写了十年技术文章。",
  motto: "一切都是最好的安排",
  // 备案号以此处为准，库里存的那份不带 -1 后缀
  icp: "鲁ICP备2022030574号-1",
  github: "https://github.com/mxx1111",
  gitee: "https://gitee.com/muxiongxiong",
  csdn: "https://blog.csdn.net/qq_34137397",
  email: "2451999120@qq.com",
  phone: "15066675713",
  // 微信与手机号同号
  wechat: "15066675713",
  location: "山东济南",
  // 原图床 blogobs.88688.team 已无解析，头像改为自托管
  avatar: "/imgs/avatar/muxiongxiong.jpg",
  careerStartYear: CAREER_START_YEAR,
  get careerYears() {
    return new Date().getFullYear() - CAREER_START_YEAR;
  }
};

/**
 * 公司信息，数据取自 sdruizer.com 官网公开内容
 */
export const company = {
  name: "山东睿泽网络科技有限公司",
  shortName: "睿泽科技",
  site: "https://sdruizer.com/",
  founded: 2018,
  location: "山东省济南市",
  tagline: "医防融合 · 体卫融合 · 医疗医保信息化",
  desc:
    "2018 年在济南成立，业务分医疗健康信息化、智慧工会、电梯追溯与特种设备监管三条主线。医疗这条线有区域慢病管理、院内慢病管理、医保慢病监管、互联网医院、数智长护、慢病鉴定六款产品，项目已落地内蒙古、山东、安徽、甘肃、新疆等多个省份，并为美国纽约的护理公司做过定制开发。",
  facts: [
    { value: "2018", label: "公司成立" },
    { value: "3", label: "业务主线" },
    { value: "30+", label: "软件著作权" },
    { value: "国高新", label: "高新技术企业" }
  ],
  honors: [
    "2026 全国医学模拟人和健康传感器智能感知大赛二等奖（健康传感器赛道）",
    "2026 全国智慧医保大赛已晋级决赛",
    "2025 全国智慧医保大赛三等奖（长护险项目）",
    "国家高新技术企业（2024 年认证）",
    "山东省科技型中小企业（2024 年）",
    "30 余项软件著作权与专利"
  ],
  regions: [
    "内蒙古兴安盟扎赉特旗",
    "内蒙古鄂尔多斯鄂托克旗",
    "内蒙古包头市",
    "内蒙古呼和浩特",
    "山东济南历城区",
    "山东济南钢城区",
    "山东潍坊",
    "福建厦门",
    "安徽亳州蒙城县",
    "甘肃岷县",
    "新疆疏勒",
    "美国纽约（海外定制开发）"
  ]
};

/**
 * 行业解决方案
 * demo 有值时卡片显示「在线演示」按钮，点开是可直接浏览的方案页
 */
export const solutions = [
  {
    analyticsId: "solution_chronic",
    name: "区域慢病管理平台",
    tagline: "县域慢病管理中心",
    desc:
      "覆盖高血压、糖尿病、冠心病、慢阻肺、脑卒中、慢性肾脏病六个病种，对标《县域慢病管理中心建设总体方案和评价标准（2025 版）》，串起县人民医院、乡镇卫生院、村卫生室三级协同。",
    tags: ["慢病筛查", "健康档案", "远程会诊", "数据大屏"],
    demo: "https://sggg.88688.team/demo/"
  },
  {
    name: "数智长护整体监管",
    analyticsId: "solution_ltci",
    tagline: "长护险全流程六端协同",
    desc:
      "覆盖长护险经办、失能评估、上门服务、健康监测、视频远程核查、AI 智能体到费用结算的完整闭环。济南历城区项目拿了 2025 年全国智慧医保大赛三等奖，2026 年再度晋级该赛事决赛。",
    tags: ["失能评估", "六端协同", "智能监管", "基金结算"],
    demo: "https://chx.sdruizer.com/demo/"
  },
  {
    name: "智慧电梯追溯维保",
    analyticsId: "solution_elevator",
    tagline: "一物一码，全程追溯",
    desc:
      "电梯从出厂、安装、注册到日常维保的全生命周期追溯，一梯一码，维保过程留痕可查，监管部门与物业各看各的那一份。",
    tags: ["一物一码", "维保留痕", "全程追溯", "特种设备"],
    demo: "https://dianti.88688.team/demo/"
  }
];

/**
 * 公司其他产品线，暂无单独演示页
 */
export const otherPlatforms = [
  {
    name: "院内慢病管理平台",
    desc: "以医院为枢纽，构建院内院外一体化的慢病管理闭环，做患者全周期的连续管理。"
  },
  {
    name: "医保慢病监管平台",
    desc: "面向医保部门，事前预警、事中监控、事后分析，盯住基金的安全运行。"
  },
  {
    name: "互联网医院服务平台",
    desc: "依托实体医疗资源做线上复诊、电子处方、药品配送与医保在线结算。"
  },
  {
    name: "医保慢病鉴定系统",
    desc: "慢病鉴定的线上化与标准化，从申请、审核到结果发放全流程数字化。"
  },
  {
    name: "工会集中报账系统",
    desc: "面向工会组织的集中化报账平台，票据电子化、审批线上化、账目透明化。已在太原市总工会、太钢集团工会、甘肃省总工会上线，河南省总工会部署中。"
  },
  {
    name: "工会集中核算平台",
    desc: "统一科目与账簿、多层级合并报表、审计留痕，上级工会实时掌握下属组织财务全貌。"
  }
];

export const timeline = [
  {
    period: "现在",
    title: "做医疗信息化，兼做自己的产品",
    desc:
      "在山东睿泽做医疗与医保方向的系统：慢病管理、长护险经办与监管、互联网医院，近期还拓展了智慧工会与电梯追溯两条线。对从政策口径到系统落地的完整链路有多轮实践，熟悉各环节的关键问题。业余时间开发自己的小程序与开源工具。"
  },
  {
    period: "技术经理",
    title: "带团队做政府与医疗项目",
    desc:
      "从学校出来进公司做技术，从两个人的小项目开始，做到带团队交付全国性填报平台、医院系统和各地的医保项目。技术栈从基于若依的 Spring Boot + Vue 到 mybatis-plus + Avue，均在项目实战中积累而来。"
  },
  {
    period: "2021 - 2022",
    title: "学校教学主管",
    desc:
      "从只管自己一个班，到要管整个校区所有班级的教学质量、课程体系、教材与物资。去武汉参加过全国教学交流分享会，回来给全校老师做分享。"
  },
  {
    period: "2015 - 2021",
    title: "学校任教，教计算机",
    desc:
      "留校任教五年。前端从 HTML5、CSS3 讲到 JavaScript 和 Vue，后端讲 Java、JSP、Servlet、SSH、SSM，也带过 C# 的 ado.net、ASP 与 WinForm，数据库以 MySQL、SQL Server、Oracle 为主。连续两年优秀员工。这几年白天在讲台教学，晚上仍回酒店值夜班；后来酒店老板开了羊汤馆，周六日和晚间就过去帮忙打羊汤、打包外卖、烤烧饼，两边都没有落下。"
  },
  {
    period: "转行",
    title: "白天上学，晚上值夜班",
    desc:
      "在酒店前台第一次接触电脑，从网页上了解到程序员这个职业，随后买来 Java 书籍自学 JDK。为了筹措数万元学费，白天在培训学校上课，放学后骑车回酒店值夜班，从下午六点到次日早上八点，如此坚持了很长时间。在校期间一直是项目组长，带队做的 OA 系统拿了 IT 精英大赛全校冠军。"
  },
  {
    period: "起点",
    title: "酒店前台收银",
    desc:
      "从山西坐十个小时火车到济南，凌晨三点在火车站出站口铺报纸睡了一觉，天亮沿街挨家问要不要人，最后被车站街一家酒店的经理留下做前台。"
  }
];

/**
 * 自己写、自己运营的产品
 * status: running 在运营 / building 开发中 / opensource 开源
 * link 为空时卡片不显示跳转按钮
 * qrcode 填小程序码图片地址后，卡片会显示扫码入口
 */
export const products = [
  {
    analyticsId: "product_xiaoyu",
    name: "小鱼早晚安",
    type: "微信小程序",
    status: "running",
    accent: "#4f8cff",
    desc:
      "帮助用户坚持早睡早起的小程序，提供打卡、目标、待办、星光币与伙伴互相监督等功能。",
    tags: ["打卡", "习惯养成", "社交"],
    appid: "wx42110986605515a0",
    qrcode: "/imgs/mini/xiaoyu-qrcode.jpg",
    link: ""
  },
  {
    name: "雄雄的工具箱",
    analyticsId: "product_toolbox",
    type: "微信小程序",
    status: "running",
    accent: "#22c1a4",
    desc:
      "集合日常高频使用的小工具：视频去水印、图片压缩、金额转大写、各类计算器与文本处理。",
    tags: ["实用工具", "去水印", "图像处理"],
    appid: "wx5b493dc0080aeda5",
    qrcode: "",
    link: ""
  },
  {
    name: "穆氏家谱",
    analyticsId: "product_family",
    type: "微信小程序",
    status: "running",
    accent: "#9a7b4f",
    desc:
      "2025 年起整理翠头村穆氏支系家谱，并自研小程序上线，族人扫码即可查询世系与辈分。",
    tags: ["家谱", "族谱查询", "自研"],
    appid: "",
    hint: "微信搜「穆氏家谱」",
    qrcode: "/imgs/mini/jiapu-qrcode.jpg",
    link: ""
  },
  {
    name: "开源项目",
    analyticsId: "github",
    type: "GitHub",
    status: "opensource",
    accent: "#334155",
    desc:
      "十余个日常在用的小工具与实验性项目，包括公众号写作助手、文件转 Markdown、自托管面板等。",
    tags: ["开源", "AI 工具", "自托管"],
    link: "https://github.com/mxx1111"
  }
];

/**
 * 写作与账号
 * CSDN 数据是 2026-08-31 的快照，手工维护
 */
export const writing = {
  csdn: {
    name: "CSDN 博客",
    handle: "穆雄雄",
    link: "https://blog.csdn.net/qq_34137397",
    joined: "2016 年 3 月",
    badges: ["人工智能领域优质创作者", "后端开发领域专家"],
    stats: [
      { value: "1345", label: "原创文章" },
      { value: "348 万", label: "累计访问" },
      { value: "6.6 万", label: "粉丝" },
      { value: "38", label: "专栏" }
    ],
    columns: [
      { name: "Java 技术", count: 540 },
      { name: "数据库", count: 56 },
      { name: "JavaScript", count: 57 },
      { name: "实施/运维", count: 49 },
      { name: "VUE", count: 34 },
      { name: "Html + CSS", count: 32 },
      { name: "教育教学", count: 32 },
      { name: "Linux 操作", count: 27 },
      { name: "鸿蒙", count: 12 }
    ]
  }
};

// 公众号，数据为 2026-08-31 快照
export const accounts = [
  {
    analyticsId: "mp_classroom",
    name: "雄雄的小课堂",
    type: "生活自媒体",
    location: "山东 济南",
    followers: "1.5 万",
    posts: "684 篇原创",
    desc:
      "长护险相关政策深度研究与信息化监管技术探索，慢病信息化管理模式研究与监管技术探索。兼有技术随笔与日常记录。",
    avatar: "/imgs/mp/xiaoketang-avatar.jpg",
    qrcode: "/imgs/mp/xiaoketang-qrcode.jpg"
  },
  {
    name: "长护视点",
    analyticsId: "mp_ltci",
    type: "长护险垂直号",
    location: "山东 济南",
    followers: "5000+",
    posts: "每日长护险简报",
    desc:
      "长护险政策解读、试点成果总结与深度研究报告，以及智慧养老、数智长护、智能评估、AI 智护、长护陪伴、居家护理相关内容。",
    avatar: "/imgs/mp/changhu-avatar.jpg",
    qrcode: "/imgs/mp/changhu-qrcode.jpg"
  }
];

/**
 * 开源项目，数据取自 github.com/mxx1111
 * 手工维护，不走接口，避免前端跨域和速率限制。star 数是记录当时的快照，
 * 展示上不强调数字，主要是让人知道有这些东西可以用。
 */
export const openSource = [
  {
    name: "wechat-mp-writer-skill",
    lang: "Python",
    stars: 14,
    desc: "微信公众号全流程写作助手，选题、写作、润色、配图到发布的完整工作流",
    link: "https://github.com/mxx1111/wechat-mp-writer-skill-mxx"
  },
  {
    name: "file2md",
    lang: "Vue",
    stars: 4,
    desc: "纯前端文件转 Markdown，支持 PDF、Word、Excel、HTML，本地处理不上传",
    link: "https://github.com/mxx1111/file2md"
  },
  {
    name: "spare-cycles",
    lang: "JavaScript",
    stars: 4,
    desc: "订阅制 AI 编码工具的余量互助任务板，有余力的人帮别人把任务做成 PR",
    link: "https://github.com/mxx1111/spare-cycles"
  },
  {
    name: "mdlook",
    lang: "Vue",
    stars: 3,
    desc: "Markdown 排版与公众号复制工具，基于 doocs/md 演进，带 Mac 本地阅读",
    link: "https://github.com/mxx1111/mdlook"
  },
  {
    name: "Homelab",
    lang: "Python",
    stars: 3,
    desc: "自托管的家庭实验室安全与运维面板",
    link: "https://github.com/mxx1111/Homelab"
  },
  {
    name: "clinical-ai-safety-kit",
    lang: "Python",
    stars: 2,
    desc: "临床场景下 AI 的安全评估工具包，机器写、人来把关",
    link: "https://github.com/mxx1111/clinical-ai-safety-kit"
  },
  {
    name: "remote-code-mobile",
    lang: "TypeScript",
    stars: 1,
    desc: "自托管的手机端工作台，在手机上操作 Mac 终端与 Claude Code",
    link: "https://github.com/mxx1111/remote-code-mobile"
  },
  {
    name: "xuantuotuoV2",
    lang: "TypeScript",
    stars: 1,
    desc: "山西柳林三人扑克「宣坨坨」的 Web 实现，带单机 AI 与联机房间",
    link: "https://github.com/mxx1111/xuantuotuoV2"
  }
];

/**
 * 荣誉
 * 按时间倒序，新的加在最前面。level 用来控制标签颜色：
 * national 国家级赛事 / work 工作经历 / school 求学阶段
 * images 为空时卡片不显示图，有图会在下面排成一行缩略图
 */
export const honors = [
  {
    year: "2026",
    date: "2026 年 10 月",
    level: "community",
    award: "文章转载",
    title: "长护险文章获漯河日报社、漯河市医保局转载",
    track: "",
    org: "漯河手机报（漯河日报社主办）· 漯河市医疗保障局",
    desc:
      "10 月 7 日在公众号「雄雄的小课堂」发布《长护险｜从“够条件就能进”到“按规划配置”，青岛、漯河等地开始调整定点机构管理》，结合漯河市医保局文件，对参保人群失能人数、机构护理床位、定点机构规模做了测算。当天漯河手机报以《有人为漯河算了一笔账！》转载，次日漯河市医疗保障局官方公众号转发分享。",
    images: [
      { src: "/imgs/honor/2026-luohe-daily-repost.jpg", alt: "漯河手机报转载《有人为漯河算了一笔账！》" },
      { src: "/imgs/honor/2026-luohe-yibao-repost.jpg", alt: "漯河市医疗保障局公众号转发长护险文章" }
    ]
  },
  {
    year: "2026",
    date: "2026 年 8 月",
    level: "national",
    award: "晋级决赛",
    title: "全国智慧医保大赛",
    track: "",
    org: "国家医疗保障局、北京市人民政府 联合主办",
    desc:
      "赛事在北京举行，国家医保局大数据中心、北京市医保局、北京市政务服务和数据管理局等单位承办，项目已晋级决赛。",
    images: [
      { src: "/imgs/honor/2026-yibao-beijing.jpg", alt: "2026 全国智慧医保大赛现场，中国北京" }
    ]
  },
  {
    year: "2026",
    date: "2026 年 8 月",
    level: "national",
    award: "二等奖",
    title: "全国医学模拟人和健康传感器智能感知大赛",
    track: "健康传感器赛道",
    org: "国家医疗保障局、湖南省人民政府 联合主办",
    desc: "",
    images: [
      { src: "/imgs/honor/2026-sensor-plaque.jpg", alt: "2026 全国医学模拟人和健康传感器智能感知大赛二等奖奖牌" },
      { src: "/imgs/honor/2026-sensor-stage.jpg", alt: "2026 全国医学模拟人和健康传感器智能感知大赛颁奖现场" },
      { src: "/imgs/honor/2026-sensor-badge.jpg", alt: "2026 大赛参会证，中国长沙" },
      { src: "/imgs/honor/2026-sensor-wall.jpg", alt: "2026 全国医学模拟人和健康传感器智能感知大赛现场，中国长沙" }
    ]
  },
  {
    year: "2026",
    date: "2026 年",
    level: "personal",
    award: "纪念",
    title: "智谱上市纪念金锣",
    track: "",
    org: "智谱",
    desc:
      "参加智谱上市活动获赠的纪念金锣，木盒上刻有其使命——让机器像人一样思考。",
    images: [
      { src: "/imgs/honor/2026-zhipu-gong.jpg", alt: "智谱上市纪念金锣" }
    ]
  },
  {
    year: "2025",
    date: "2025 年 12 月",
    level: "national",
    award: "三等奖",
    title: "全国智慧医保大赛",
    track: "AI 数智长护队",
    org: "国家医疗保障局 主办",
    desc:
      "参赛项目：基于数据要素驱动的人工智能长护垂直领域深度应用服务平台。",
    images: [
      { src: "/imgs/honor/2025-yibao-plaque.jpg", alt: "2025 全国智慧医保大赛三等奖奖牌" },
      { src: "/imgs/honor/2025-yibao-cert.jpg", alt: "2025 全国智慧医保大赛三等奖荣誉证书" },
      { src: "/imgs/honor/2025-yibao-team-badge.jpg", alt: "2025 全国智慧医保大赛颁奖典礼获奖团队证，中国上海" },
      { src: "/imgs/honor/2025-yibao-wall.jpg", alt: "2025 全国智慧医保大赛参赛单位墙" }
    ]
  },
  {
    year: "2025",
    date: "2025 年 10 月 25 日",
    level: "community",
    award: "受邀分享",
    title: "鸿蒙领航者私享会",
    track: "",
    org: "长沙 · 智谷 A5",
    desc:
      "受邀参加鸿蒙领航者私享会，做主题分享，并与各地开发者分组交流鸿蒙生态的应用落地。",
    images: [
      { src: "/imgs/honor/2025-harmony-talk-1.jpg", alt: "鸿蒙领航者私享会主题分享" },
      { src: "/imgs/honor/2025-harmony-talk-2.jpg", alt: "鸿蒙领航者私享会分享现场" },
      { src: "/imgs/honor/2025-harmony-group-1.jpg", alt: "鸿蒙领航者私享会分组交流" },
      { src: "/imgs/honor/2025-harmony-group-2.jpg", alt: "鸿蒙领航者私享会分组讨论" },
      { src: "/imgs/honor/2025-harmony-group-3.jpg", alt: "鸿蒙领航者私享会活动现场" }
    ]
  },
  {
    year: "2025",
    date: "2025 年",
    level: "community",
    award: "影响力认证",
    title: "全网影响力认证 · IT 技术领域卓越贡献者",
    track: "",
    org: "极星会",
    desc:
      "认证时点全网粉丝总计 71,215，覆盖 CSDN、InfoQ、51CTO、掘金、微信公众号、GitHub 等技术社区与平台。",
    images: [
      { src: "/imgs/honor/2025-jixinghui-cert.jpg", alt: "极星会全网影响力认证证书，全网粉丝 71215" }
    ]
  },
  {
    year: "2025",
    date: "2025 年起",
    level: "personal",
    award: "修谱",
    title: "整理翠头村穆氏支系家谱",
    track: "",
    org: "",
    desc:
      "自 2025 年起整理翠头村穆氏支系家谱，并自研家谱小程序上线，族人扫码即可查阅世系。",
    images: []
  },
  {
    year: "2022",
    date: "2022 年 10 月",
    level: "community",
    award: "创作导师",
    title: "CSDN 创作之秋 · 领军人物｜创作导师",
    track: "",
    org: "CSDN",
    desc: "在 2022 创作之秋活动中完成导师任务，获颁领军人物、创作导师证书。",
    images: [
      { src: "/imgs/honor/2022-csdn-mentor-cert.jpg", alt: "CSDN 2022 创作之秋领军人物创作导师证书" }
    ]
  },
  {
    year: "2022",
    date: "2022 年 10 月",
    level: "community",
    award: "三等奖",
    title: "CSDN 猿创征文第二季",
    track: "技术成长之路征文",
    org: "CSDN 社区官方",
    desc:
      "获奖文章为《从酒店前台收银到软件研发教学主管到技术经理之路》，全文已同步发布于本站。",
    images: [
      { src: "/imgs/honor/2022-csdn-essay3-cert.jpg", alt: "CSDN 猿创征文第二季三等奖证书" }
    ]
  },
  {
    year: "2022",
    date: "2022 年",
    level: "community",
    award: "博客专家",
    title: "CSDN 博客专家 · 万粉博主",
    track: "",
    org: "CSDN",
    desc:
      "2022 年 6 月粉丝过万，同年 9 月获授「博客专家」称号，并获 CSDN 定制奖牌，刻有注册日期与粉丝数里程碑。",
    images: [
      { src: "/imgs/honor/2022-csdn-plaque.jpg", alt: "CSDN 定制奖牌，万粉博主与博客专家" },
      { src: "/imgs/honor/2022-csdn-expert-cert.jpg", alt: "CSDN 博客专家荣誉证书" }
    ]
  },
  {
    year: "2022",
    date: "2022 年度",
    level: "work",
    award: "年度优秀员工",
    title: "山东睿泽网络科技有限公司",
    track: "",
    org: "",
    desc: "",
    images: [
      { src: "/imgs/honor/2022-ruize-employee.jpg", alt: "山东睿泽 2022 年度优秀员工证书" }
    ]
  },
  {
    year: "任教期间",
    date: "",
    level: "work",
    award: "连续多年优秀员工",
    title: "学校教学岗",
    track: "",
    org: "",
    desc: "后升任学校教学主管，负责整个校区的教学质量、课程体系与教材物资。",
    images: []
  },
  {
    year: "高中",
    date: "",
    level: "school",
    award: "全年级第一",
    title: "求学阶段",
    track: "",
    org: "",
    desc: "",
    images: []
  }
];

/**
 * 导航页分组，/nav 页面按这个渲染
 * external 为 true 时用 a 标签开新窗口，否则用 router-link
 */
/**
 * 长护险社群与知识库
 */
export const chxCommunity = {
  intro:
    "围绕长护险运营的全国性交流社群：鼠群、牛群、虎群三个交流群各约 500 人，兔群正在筹备；另设立了长护险领域的专业知识库，目前已有 1000 余人加入，仍在持续增长。",
  facts: [
    { value: "3", label: "全国交流群（鼠、牛、虎）" },
    { value: "1500+", label: "交流群成员" },
    { value: "1000+", label: "知识库加入人数" },
    { value: "筹备中", label: "第四个群（兔群）" }
  ]
};

export const navGroups = [
  {
    title: "行业方案",
    desc: "点开就能看的方案演示页",
    links: [
      { name: "山东睿泽官网", desc: "公司介绍、产品矩阵与合作案例", href: company.site, external: true },
      { name: "区域慢病管理平台", desc: "县域三级协同的慢病管理方案", href: "https://sggg.88688.team/demo/", external: true },
      { name: "数智长护整体监管", desc: "长护险经办到结算的全流程闭环", href: "https://chx.sdruizer.com/demo/", external: true },
      { name: "智慧电梯追溯维保", desc: "一物一码的电梯维保追溯平台", href: "https://dianti.88688.team/demo/", external: true }
    ]
  },
  {
    title: "自己的产品",
    desc: "自研并持续运营的小程序与工具",
    links: [
      { name: "小鱼早晚安", desc: "微信搜「小鱼早晚安」，早睡早起打卡", href: "/works", external: false },
      { name: "雄雄的工具箱", desc: "微信搜「雄雄的工具箱」，视频去水印等实用工具", href: "/works", external: false },
      { name: "全部产品与项目", desc: "站内的产品清单", href: "/works", external: false },
      { name: "开源项目", desc: "十余个开源工具项目，托管在 GitHub", href: profile.github, external: true }
    ]
  },
  {
    title: "技术写作",
    desc: "技术文章都在这几个地方",
    links: [
      { name: "我的故事", desc: "从前台到技术经理的完整经历", href: "/story", external: false },
      { name: "CSDN 博客", desc: "1345 篇原创，累计 348 万访问", href: profile.csdn, external: true },
      { name: "公众号 · 雄雄的小课堂", desc: "1.5 万粉丝，长护险与慢病信息化", href: "/about", external: false },
      { name: "公众号 · 长护视点", desc: "5000+ 粉丝，长护险政策解读与简报", href: "/about", external: false }
    ]
  },
  {
    title: "代码",
    desc: "开源仓库",
    links: [
      { name: "GitHub", desc: "github.com/mxx1111，十几个开源项目", href: profile.github, external: true },
      { name: "Gitee", desc: "gitee.com/muxiongxiong，国内仓库", href: profile.gitee, external: true },
      { name: "开源项目清单", desc: "站内整理的项目介绍", href: "/#opensource", external: false },
      { name: "公众号写作助手", desc: "选题到发布的完整工作流，star 最多的一个", href: "https://github.com/mxx1111/wechat-mp-writer-skill-mxx", external: true }
    ]
  },
  {
    title: "找我",
    desc: "合作咨询与日常联系",
    links: [
      { name: "手机 / 微信", desc: profile.phone + "（微信同号）", href: "tel:" + profile.phone, external: true },
      { name: "邮箱", desc: profile.email, href: "mailto:" + profile.email, external: true },
      { name: "关于我", desc: "完整的经历、荣誉与联系方式", href: "/about", external: false },
      { name: "留言板", desc: "随便说点什么", href: "/message", external: false }
    ]
  }
];
